"use strict";

var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createResourceReducer;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _fluxStandardAction = require("flux-standard-action");

var _warning = _interopRequireDefault(require("@flowio/warning"));

var _language = require("../utilities/language");

var _introspection = require("../utilities/introspection");

var _plugins = require("../plugins");

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

function normalizeOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread(_objectSpread({}, options), {}, {
    idAttribute: (0, _language.getProperty)(options, ['idAttribute'], 'id'),
    initialState: (0, _language.getProperty)(options, ['initialState'], {}),
    plugins: (0, _language.getProperty)(options, ['plugins'], [])
  });
}

function createResourceReducer(resourceType, options) {
  var normalizedOptions = normalizeOptions(options);
  var idAttribute = normalizedOptions.idAttribute,
      initialState = normalizedOptions.initialState,
      plugins = normalizedOptions.plugins;
  (0, _warning.default)((0, _language.isString)(resourceType), 'The value of `resourceType` argument passed to `createResourceReducer` is ' + 'not a string. The resource name must be a string. You should check your ' + 'reducer configuration.');
  var allPlugins = plugins.concat([_plugins.requestPlugin, _plugins.resourcePlugin]);
  var computedPlugins = allPlugins.map(function (plugin) {
    var result = plugin(resourceType, normalizedOptions);
    (0, _warning.default)((0, _language.isFunction)(plugin), 'A plugin that was initialized did not return a function. Plugins should ' + 'return a function with the same signature as a Redux reducer.');
    return result;
  });

  var computedInitialState = _objectSpread({
    idAttribute: idAttribute,
    resourceType: resourceType,
    metadata: {},
    lists: {},
    requests: {},
    resources: {}
  }, initialState); // eslint-disable-next-line default-param-last


  return function resourceReducer() {
    var previousState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : computedInitialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;

    if (!(0, _introspection.isResourceAction)(action) && !(0, _introspection.isRequestAction)(action)) {
      return previousState;
    }

    (0, _warning.default)((0, _fluxStandardAction.isFSA)(action), 'A Redux Resource action of type `%s` was dispatched and is not ' + 'FSA-compliant. You should check your actions creators to make sure ' + 'Redux Resource actions are FSA-compliant. ');
    return computedPlugins.reduce(function (previousValue, computedPlugin) {
      return computedPlugin(previousValue, action);
    }, previousState);
  };
}